(() => {
  if (window.fsDeferredImagesInitialized) return;
  window.fsDeferredImagesInitialized = true;
  const initializedCards = new WeakSet();
  const observedGrids = new WeakSet();

  const upgrade = (image) => {
    if (!image?.dataset.fsCardSrc) return;
    image.closest('picture')?.querySelectorAll('source[data-fs-card-srcset]').forEach((source) => {
      source.srcset = source.dataset.fsCardSrcset;
      delete source.dataset.fsCardSrcset;
    });
    if (image.dataset.fsCardSizes) image.sizes = image.dataset.fsCardSizes;
    if (image.dataset.fsCardSrcset) image.srcset = image.dataset.fsCardSrcset;
    image.src = image.dataset.fsCardSrc;
    delete image.dataset.fsCardSrcset;
    delete image.dataset.fsCardSizes;
    delete image.dataset.fsCardSrc;
  };

  const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      upgrade(entry.target);
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '120px 0px' }) : null;

  const matching = (root, selector) => [
    ...(root.matches?.(selector) ? [root] : []),
    ...root.querySelectorAll(selector),
  ];

  const initialize = (root) => {
    matching(root, '[data-fs-card-primary][data-fs-card-src]').forEach((image) => {
      if (observer) observer.observe(image);
      else upgrade(image);
    });
    matching(root, '.product-card-wrapper:has([data-fs-card-secondary])').forEach((card) => {
      if (initializedCards.has(card)) return;
      initializedCards.add(card);
      const upgradeSecondary = () => upgrade(card.querySelector('[data-fs-card-secondary]'));
      card.addEventListener('pointerenter', upgradeSecondary, { once: true });
      card.addEventListener('focusin', upgradeSecondary, { once: true });
    });

    // Sorting and variant changes replace image content without a section-load event.
    matching(root, '#ProductGridContainer, media-gallery[data-fs-defer-images] ul').forEach((grid) => {
      if (observedGrids.has(grid)) return;
      observedGrids.add(grid);
      new MutationObserver((records) => {
        records.forEach((record) => {
          record.removedNodes.forEach((node) => {
            if (node.nodeType !== Node.ELEMENT_NODE) return;
            matching(node, '[data-fs-card-primary]').forEach((image) => observer?.unobserve(image));
          });
          record.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) initialize(node);
          });
        });
      }).observe(grid, { childList: true });
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
